import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { FormModeProvider } from '../../base/contexts/FormModeContext.tsx'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'
import { Loadable } from '../base/components/Lodable.tsx'
import { DeaInputProps } from './interfaces'
import {
  DeaFormMode,
  deaFormModeConfig,
  deaFormModeDefault,
} from './services/deaFormMode.ts'

const DeaGestion = Loadable(lazy(() => import('./view/DeaGestion.tsx')))
const DeaNuevoRegistro = Loadable(lazy(() => import('./view/nuevo/DeaNuevoRegistro.tsx')))

export const deaRoutesMap = {
  gestion: {
    path: '/destruccion',
    name: 'Gestion',
    action: 'DESTRUCCION_ARTICULO',
  },
  nuevo: {
    path: '/destruccion/nuevo',
    name: 'Nuevo Registro',
    action: 'DESTRUCCION_ARTICULO_NUEVO',
  },
  actualizar: {
    path: '/destruccion/actualizar/:id',
    name: 'Actualizar',
    action: 'DESTRUCCION_ARTICULO_ACTUALIZAR',
  },
}

const deaRoutes = [
  {
    path: deaRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <DeaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: deaRoutesMap.nuevo.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<DeaInputProps, DeaFormMode>
          mode={'create'}
          config={deaFormModeConfig}
          defaults={deaFormModeDefault}
        >
          <DeaNuevoRegistro />
        </FormModeProvider>
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default deaRoutes
